import React, {useContext} from 'react'
import Container from '../components/container/container'
import Footer from '../components/footer/footer'
import Navigation from '../components/navigation/navigation'
import PageTitle from '../components/page-header/pageTitle'
import { ProductContext } from '../stores/session';

export default function GenericPageContainer({
  title,
  children,
  className,
  titleRight,
  titleIconClass,
  containerWidth
}) {
  const product = useContext(ProductContext)
  return (
    <div className={['grid grid-gap-15', className].join(' ')}>
      <Navigation />
      <Container width={containerWidth}>
        <PageTitle iconClass={product ? product.icon + ' fa-2x colour-primary' : titleIconClass} title={title} titleRight={<div style={{display: 'flex'}}>{titleRight}</div>} />
      </Container>
      <Container width={containerWidth}>
        {children}
      </Container>
      <Footer />
    </div>
  )
}
